module.exports = __webpack_public_path__ + "img/error.e88f427a.png";